module.exports = "<g transform=\"translate(0,5)\">\n  <polygon points=\"0,0 20,0 10,15\" fill=\"currentColor\" />\n</g>\n"